import { useLinkedAccounts } from "@store/linkedAccountSlice";
import { useMemo } from "react";
import { Trans } from "react-i18next";
import { groupAccountsByPlatform } from "./groupAccountsByPlatform";
import { getSupportedPlatforms } from "./platformConfig";
import { PlatformLinkedAccountsSection } from "./PlatformLinkedAccountsSection";

export const LinkedAccounts = () => {
  const { items, status } = useLinkedAccounts();
  const groups = useMemo(() => groupAccountsByPlatform(items), [items]);

  // 始终展示受支持平台的分区（即使该平台尚无账号），以保证零账号时仍有「Add account」入口；
  // 首次加载完成前不渲染空分区，避免闪动。
  const sections = useMemo(() => {
    const accountsByPlatform = new Map(groups.map(({ platform, accounts }) => [platform, accounts]));
    const supported = getSupportedPlatforms().map((platform) => ({
      platform,
      accounts: accountsByPlatform.get(platform) ?? [],
    }));
    return status === "succeeded" ? supported : supported.filter(({ accounts }) => accounts.length > 0);
  }, [groups, status]);

  return (
    <div className="flex h-full min-h-0 flex-col gap-[24px] p-[24px]">
      <h2 className="text-[16px] font-semibold leading-[22px] text-kds-fg">
        <Trans>Linked Accounts</Trans>
      </h2>
      <div className="flex flex-col gap-[16px]">
        {sections.map(({ platform, accounts }) => (
          <PlatformLinkedAccountsSection key={platform} platform={platform} accounts={accounts} />
        ))}
      </div>
    </div>
  );
};
